import React from 'react';
import {
  Button,
  Grid,
  FormControl,
  TextField,
  CircularProgress,
  Alert,
} from '@mui/material';
import { currency } from '../../utils/utils';
import useHook from './useHook';
import styles from './styles.module.scss';

const ContenedorEnvios2 = () => {
  const {
    cp,
    reduxCp,
    loading,
    shipping,
    fechaEntrega,
    handleChange,
    handleClean,
  } = useHook();

  return (<>
    <div className={styles.box} style={{ maxWidth: "600px" }}>
      {(!cp || cp.length < 4)
        ?
        <div className={styles.container}>
          <p><b><u>Ingresá tu código postal para calcular tu envío</u></b></p><br />
          <div className={styles.container} style={{ maxWidth: "220px" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12}>
                <FormControl fullWidth>
                  <TextField
                    required
                    fullWidth
                    id="cp"
                    label="Código postal"
                    variant="outlined"
                    type="tel"
                    value={cp}
                    autoComplete="current-email"
                    color="secondary"
                    onChange={(e) => handleChange(e.target.value)}
                    InputProps={{
                      style: {
                        borderRadius: "100px",
                        background: "#fff",
                        padding: "0 6px"
                      },
                    }}
                    inputProps={{ maxLength: 4 }}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </div>
        :
        <div className={styles.container}>
          <p><b><u>Envíos disponibles para {reduxCp}</u></b></p><br />
          {loading &&
                        <CircularProgress size="30px" />
          }
          {!loading && shipping &&
                        <div className={styles.item}>
                          <div className={styles.flexLine}>
                            <p>Envío a domicilio por Andreani</p>
                            <p>$ {currency(Math.ceil(shipping.tarifaConIva))}</p>
                          </div>
                          <em><u>Fecha de entrega estimada</u>: {fechaEntrega.format('dddd D [de] MMMM')}</em>
                          <br /><br />
                          <Alert severity="info">Una vez despachado tu paquete recibirás un email con el seguimiento y la fecha exacta en el que lo vas a recibir.</Alert>
                        </div>
          }
          {!loading && !shipping &&
                        <div className={styles.item}>
                          <em>No pudimos cargar opciones de envío.</em>
                        </div>
          }
          <br /><br />
          <Button
            variant='text'
            color="secondary"
            onClick={handleClean}
          ><p><u>Cambiar código postal</u></p></Button>
        </div>
      }
    </div>
  </>);
};

export default ContenedorEnvios2;
